import React, { Component } from 'react';
import ReactDom from 'react-dom';

import { Provider } from 'react-redux';
import { Route, Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import store from './store';
import OpinionsList from './components/opinions-list';

const history = createBrowserHistory();

export default class OpinionsListComponent extends Component {
	render() {
		return (
			<Provider store={ store }>
				<Router history={ history }>
					<switch>
						<Route exact path="/opinions-library/" component={ OpinionsList } />
						<Route path="/opinions-library/type/:type" component={ OpinionsList } />
					</switch>
				</Router>
			</Provider>
		);
	}
}

var OpinionsElement = document.getElementById( 'OpinionsElement' );
if ( OpinionsElement ) {
	ReactDom.render( <OpinionsListComponent />, OpinionsElement );
}